/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { getButtonFocus } from 'styles/variables';
import EmptyBtn from 'components/UI/EmptyBtn';
import hexToRgb from 'services/hexToRGB';

const Arrow = ({ color = '#ffffff' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6.375 3.75L11.625 9L6.375 14.25"
        style={{
          stroke: color,
          strokeWidth: 1.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
    </svg>
  );
};

const Btn = ({
  dir = 'next',
  size = 60,
  top = '',
  enabled = true,
  color = '#494949',
  hoverColor,
  arrowColor = '#ffffff',
  style = {},
  onClick,
  ...props
}) => {
  const height = props.height || '100%';
  const heightOffset = 150;

  const ariaDisabled = {};
  if (!enabled) {
    ariaDisabled['aria-disabled'] = true;
  }

  const { r, g, b } = hexToRgb(color);
  const hoverColorToRGB = hexToRgb(hoverColor || color);

  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        align-items: center;
        ${`${dir === 'prev' ? 'left' : 'right'} : 0px;`}
        top: ${heightOffset / 2}px;
        width: ${size + 20}px;
        height: ${height - heightOffset}px;
        background: transparent;
      `}
      onClick={e => {
        onClick();
      }}
    >
      <EmptyBtn
        css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        ${`${dir === 'prev' ? 'left' : 'right'} : 10px;`}
        width: ${size}px;
        height: ${size}px;
        background-color: rgba(${r}, ${g}, ${b}, ${enabled ? 1 : 0.45});
        background-position: center;
        border-radius: 50%;
        transform: scaleX(${dir === 'next' ? 1 : -1});
        transition: opacity 0.2s;
        cursor: ${enabled ? 'pointer' : 'auto'};
        transition: background-color 0.1s;
        :-webkit-backface-visibility: hidden;

        ${enabled &&
          `&:hover {
            background-color: rgba(${hoverColorToRGB.r}, ${
            hoverColorToRGB.g
          }, ${hoverColorToRGB.b}, ${hoverColor ? 1 : 0.45});
          }
        `}

        &:focus {
          ${getButtonFocus('#494949')}
        }
        
        @media (max-width: 480px) {
          ${`${dir === 'prev' ? 'left' : 'right'} : 5px;`}
          transform: scale(${dir === 'next' ? 0.75 : -0.75});
          transform-origin: center;
        }
      `}
        style={style}
        tabIndex={props.tabIndex}
        ariaLabel={dir === 'prev' ? 'Previous slide' : 'Next slide'}
        {...ariaDisabled}
        disabled={!enabled}
      >
        <div
          style={{
            position: 'relative',
            left: 1,

            width: 18,
            height: 18,
          }}
        >
          <Arrow color={arrowColor} />
        </div>
      </EmptyBtn>
    </div>
  );
};

export default Btn;
